export default __webpack_public_path__ + "097470a79b1cf7080e4406d80fc97338.svg";